
class LocalStorage {
    static getItem: any;

    /** SOMENTE PARA SUBMASTER */
    saveAuthToken(token: string, name:string, email:string, id:string,submaster_logo_url:string, webUser?: any) : void {
      localStorage.setItem('authToken', token);
      localStorage.setItem('name', name);
      localStorage.setItem('email', email);
      localStorage.setItem('id', id);
      localStorage.setItem('submaster_logo_url', submaster_logo_url)
      if (webUser) {
        localStorage.setItem('webUser', JSON.stringify(webUser));
      } else {
        localStorage.removeItem('webUser');
      }

    }
    removeAuthToken(): void {
      localStorage.removeItem('authToken');
      localStorage.removeItem('email');
      localStorage.removeItem('name');
      localStorage.removeItem('id');
      localStorage.removeItem('submaster_logo_url');
      localStorage.removeItem('webUser');

    }
    getAuthToken(): string | null {
      return localStorage.getItem('authToken');
    }
    getName(): string | null {
      return localStorage.getItem('name');
    }
    getEmail(): string | null {
      return localStorage.getItem('email');
    }

    getId(): string | null {
      return localStorage.getItem('id');
    }
    getSubmasterLogoUrl(): string | null {
      return localStorage.getItem('submaster_logo_url');
    }
    saveSubmasterLogoUrl(submaster_logo_url: string): void {
      localStorage.setItem('submaster_logo_url', submaster_logo_url);
    }
    getWebUser(): any | null {
      try {
        const value = localStorage.getItem('webUser');
        return value ? JSON.parse(value) : null;
      } catch {
        return null;
      }
    }
    hasWebPermission(permission: string): boolean {
      const user = this.getWebUser();
      if (!user) return true;
      return user.isMaster === true || user.permissions?.[permission] === true;
    }
    isWebMasterOrLegacy(): boolean {
      const user = this.getWebUser();
      return !user || user.isMaster === true;
    }


    /** SOMENTE PARA O MASTER */

    saveAuthTokenMaster(token: string) : void {
      localStorage.setItem('authTokenMaster', token);
    }
     getAuthTokenMaster(): string | null {
      return localStorage.getItem('authTokenMaster');
    }
    removeAuthTokenMaster(): void {
      localStorage.removeItem('authTokenMaster');
    }

  }
  

  export default LocalStorage; // A classe é exportada corretamente
